import { render, staticRenderFns } from "./GroupPermission.vue?vue&type=template&id=34f41ac6"
import script from "./GroupPermission.vue?vue&type=script&lang=js"
export * from "./GroupPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports